import { Navigate, useParams } from 'react-router-dom';
import PageCaseStudy from '../templates/PageCaseStudy';
import { getProjectBySlug } from '../content';

export default function CaseStudyPage() {
  const { slug } = useParams();
  const project = getProjectBySlug(String(slug || '').replace(/\/+$/, ''));
  if (!project || !project.published) {
    return <Navigate to="/" replace />;
  }
  return <PageCaseStudy project={project} />;
}
